export default {
    history: {
        title: "History",
        customerHistory: "Customer History",
        globalHistory: "Global History",
        type: "Type",
        id: "History Type Id",
        action: "Action",
        status: "Status",
        statusReason: "Status Reason",
        description: "Description",
        modBy: "Modified By",
        started: "Started On",
        ended: "Ended On",
        duration: "Duration",
        details: "History Details",
        general: "General",
        presets: {
            jobHistory: "NCS: Job History",
            radioCommandHistory: "NCS: Radios Command History",
            towerCommandHistory: "NCS: Base Station Command History"
        },
        actions: {
            COMMAND: "Command",
            CREATE: "Create",
            DELETE: "Delete",
            TUNING: "Tuning",
            UPDATE: "Update"
        },
        statuses: {
            COMPLETED: "Completed",
            IN_PROGRESS: "In Progress",
            CANCELLED: "Cancelled",
            FAILED: "Failed"
        },
        types: {
            SET: "Set",
            TOWER: "Base Station",
            RADIO: "Radio",
            ALARM_RULE: "Alarm Rule",
            ALARM_SUPPRESSION: "Alarm Suppression",
            JOB: "Job",
            RADIO_RULE: "Radio Rule",
            NETWORK_PLAN: "Network Plan",
            TUNING: "Tuning",
            CUSTOMER: "Customer",
            CHANNEL_CONFIG: "Channel Config",
            CSV_IMPORT: "CSV Import",
            TOWER_SOFTWARE: "Tower Software",
            RNI: "RNI"
        },
        sets: {
            idList: "ID List",
            idAddList: "IDs To Add",
            idRemoveList: "IDs To Remove",
            name: "Name",
            filterList: "Filter List"
        },
        tuning: {
            tuningChanges: "Tuning Changes",
            channelBalanceChanges: "Channel Balance Changes",
            otherInfo: "Other Information"
        },
        job: {
            config: "Job Configuration",
            errors: "Job Errors",
            metrics: "Job Metrics",
            channelBal: "Channel Balancing",
            nco: "NCO",
            buddy: "Buddy",
            rapidTune: "Rapid Tune",
            buddyDistribution: "Buddy Distribution",
            eca: "ECA",
            prePostProcessing: "Pre/Post Processing"
        },
        radioRule: {
            diff: "Differences",
            update: "Updated Fields",
            created: "Created"
        },
        channelConfig: {
            deleted: "Deleted"
        }
    },
    chd: {
        attemptDNA: "Attempt information does not apply",
        attempts: "Attempts",
        changes: "Changes",
        lastAttemptDate: "Most Recent Attempt",
        nextAttemptDate: "Next Attempt",
        messages: "Messages",
        noMessages: "No messages for this history event",
        commandHistory: "Event History",
        commandEventId: "Event ID"
    },
}
